import { render, staticRenderFns } from "./infoAddress2.vue?vue&type=template&id=fd7fae70&scoped=true"
import script from "./infoAddress2.vue?vue&type=script&lang=js"
export * from "./infoAddress2.vue?vue&type=script&lang=js"
import style0 from "./infoAddress2.vue?vue&type=style&index=0&id=fd7fae70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7fae70",
  null
  
)

export default component.exports